interface SnowPlowParticle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  size: number;
  alpha: number;
  life: number;
  maxLife: number;
}

interface EmitOptions {
  x: number;
  y: number;
  carveDir: number;
  intensity: number;
  amount: number;
  rand: () => number;
}

const MAX_PARTICLES = 42;

export class SnowPlowParticles {
  private particles: SnowPlowParticle[] = [];

  emit({ x, y, carveDir, intensity, amount, rand }: EmitOptions) {
    const dir = carveDir < 0 ? -1 : 1;
    const clampedIntensity = Math.max(0, Math.min(1, intensity));
    const count = Math.max(0, Math.min(5, Math.round(amount)));

    for (let i = 0; i < count; i++) {
      const spread = (rand() - 0.5) * 1.2;
      const flyAway = -dir;
      const speed = 0.8 + rand() * 1.5 + clampedIntensity * 1.2;
      const size = 2.2 + rand() * 3.0 + clampedIntensity * 1.2;

      this.particles.push({
        x: x + dir * (8 + rand() * 9) + (rand() - 0.5) * 5,
        y: y + (rand() - 0.5) * 6,
        vx: flyAway * speed + spread,
        vy: -0.6 - rand() * 1.1 - clampedIntensity * 0.5,
        size,
        alpha: 0.50 + rand() * 0.24,
        life: 0,
        maxLife: 18 + Math.round(rand() * 12),
      });
    }

    if (this.particles.length > MAX_PARTICLES) {
      this.particles.splice(0, this.particles.length - MAX_PARTICLES);
    }
  }

  update(scrollSpeed: number) {
    if (this.particles.length === 0) return;

    for (const particle of this.particles) {
      particle.life++;
      particle.x += particle.vx;
      particle.y += particle.vy - scrollSpeed;
      particle.vx *= 0.94;
      particle.vy += 0.06;
      particle.size *= 0.955;
      particle.alpha *= 0.94;
    }

    this.particles = this.particles.filter(particle =>
      particle.life < particle.maxLife &&
      particle.alpha > 0.03 &&
      particle.size > 0.35 &&
      particle.y > -40
    );
  }

  draw(ctx: CanvasRenderingContext2D) {
    if (this.particles.length === 0) return;

    ctx.save();
    for (const particle of this.particles) {
      const lifeFade = 1 - particle.life / particle.maxLife;
      const alpha = Math.max(0, particle.alpha * lifeFade);
      if (alpha <= 0) continue;

      ctx.globalAlpha = alpha;
      ctx.strokeStyle = 'rgba(70,112,145,0.58)';
      ctx.lineWidth = 1;
      ctx.fillStyle = 'rgba(210,232,246,0.88)';
      ctx.beginPath();
      ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();

      ctx.globalAlpha = alpha * 0.62;
      ctx.fillStyle = 'rgba(122,176,214,0.50)';
      ctx.beginPath();
      ctx.arc(particle.x + particle.size * 0.24, particle.y + particle.size * 0.22, particle.size * 0.58, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  }

  clear() {
    this.particles = [];
  }

  getCount() {
    return this.particles.length;
  }

  getMaxParticles() {
    return MAX_PARTICLES;
  }
}
